import axios from '../utils/AxiosInstance'

export default {
  // namespaced: true,
  state: {
    jobLogs: {
      selectIds: [],
      filters: {},
      paginate: {},
      selectId: false
    }
  },
  mutations: {
    SET_JOBLOG_SELECT_IDS (store, ids) {
      store.jobLogs.selectIds = ids
    },
    REMOVE_JOBLOG_SELECT_IDS (store, ids) {
      store.jobLogs.selectIds = store.jobLogs.selectIds.filter((v) => { return ids.indexOf(v) === -1 })
    },
    SET_JOBLOG_SELECT_ID (store, id) {
      store.jobLogs.selectId = id
    },
    SET_JOBLOG_FILTERS (store, filters) {
      store.jobLogs.filters = filters
    },
    SET_JOBLOG_PAGINATE (store, val) {
      store.jobLogs.paginate = {
        limit: val.limit,
        page: val.page,
        pages: val.pages,
        total: val.total
      }
    }
  },
  getters: {
    getJobLogs: (store, getters) => {
      return store.jobLogs.selectIds.map((id) => {
        return getters['entities/jobLogs/find'](id)
      })
    },
    getJobLogsFilters: (store, getters) => {
      return store.jobLogs.filters
    },
    getJobLogsPaginate: (store, getters) => {
      return store.jobLogs.paginate
    },
    getJobLog: (store, getters) => {
      return getters['entities/jobLogs/find'](store.jobLogs.selectId) || {}
    }
  },
  actions: {
    /*
    selectJobLogs
    */
    selectJobLogs ({commit, dispatch, getters, state}, filters) {
      return dispatch('getJobLogs', filters)
      .then((response) => {
        commit('SET_JOBLOG_FILTERS', filters)
        commit('SET_JOBLOG_PAGINATE', response)
        commit('SET_JOBLOG_SELECT_IDS', response.docs.map((item) => { return item._id }))
        return response
      })
    },
    /*
    refreshSelectJobLogs
    */
    refreshSelectJobLogs ({commit, dispatch, getters, state}) {
      return dispatch('selectJobLogs', getters.getJobLogsFilters)
    },
    /*
    selectJobLog
    */
    selectJobLog ({commit, dispatch, getters, state}, id) {
      return dispatch('getJobLogById', id)
      .then((response) => {
        commit('SET_JOBLOG_SELECT_ID', response._id)
        return response
      })
    },
    /*
    getJobLogs
    */
    getJobLogs ({commit, dispatch, getters, state}, filters) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/jobs/${filters.job_id}/logs`, {params: filters})
      .then((response) => {
        return dispatch('entities/jobLogs/insert', {
          data: response.data.docs
        })
        .then((result) => {
          return {
            docs: result.jobLogs || [],
            limit: response.data.limit,
            page: response.data.page,
            pages: response.data.pages,
            total: response.data.total
          }
        })
      })
    },
    /*
    getJobLogById
    */
    getJobLogById ({commit, dispatch, getters, state}, filters) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/jobs/${filters.job_id}/logs/${filters._id}`)
      .then((response) => {
        return dispatch('entities/jobLogs/insert', {
          data: response.data
        })
      })
      .then((result) => {
        return result.jobLogs[0]
      })
    },
    /*
    createJobLog
    */
    createJobLog ({commit, dispatch, getters, state}, data) {
      delete data.$id

      return axios
      .post(`/accounts/${getters.getAccount._id}/jobs/${data.job_id}/logs`, data)
      .then((response) => {
        return dispatch('entities/jobLogs/insert', {
          data: response.data
        })
      })
      .then((response) => {
        return response.jobLogs[0]
      })
    },
    /*
    updateJobLog
    */
    updateJobLog ({commit, dispatch, getters, state}, data) {
      delete data.$id

      return axios
      .put(`/accounts/${getters.getAccount._id}/jobs/${data.job_id}/logs/${data._id}`, data)
      .then((response) => {
        return dispatch('entities/jobLogs/insert', {
          data: response.data
        })
      })
      .then((response) => {
        return response.jobLogs[0]
      })
    },
    /*
    deleteJobLog
    */
    deleteJobLog ({commit, dispatch, getters, state}, filters) {
      const id = filters._id

      return axios
      .delete(`/accounts/${getters.getAccount._id}/jobs/${filters.job_id}/logs/${id}`)
      .then((response) => {
        commit('REMOVE_JOBLOG_SELECT_IDS', [id])
        dispatch('entities/jobLogs/delete', id)
        return {}
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/JobLog.js